/**
 * The "current creature" behind `window.__marg.creature` (creatures §D3): set by the creature lab (and, in wave 2, by
 * «Облик»). Holds the DNA and the last build's stats.
 */
import type { CreatureDNA } from '../../shared';
import type { BuiltCreature } from '../mesh';

export interface LabCreature { dna: CreatureDNA; built: BuiltCreature; buildMs: number; partRebuilds: number; fullRebuilds: number }

let current: LabCreature | null = null;

export function setLabCreature(dna: CreatureDNA, built: BuiltCreature, buildMs: number): void {
  current = { dna, built, buildMs, partRebuilds: current?.partRebuilds ?? 0, fullRebuilds: (current?.fullRebuilds ?? 0) + 1 };
}
export const labCreature = (): LabCreature | null => current;
